import template from './addObligationBasisLineModal.html';
import controller from './addObligationBasisLineModal.controller';

let AddObligationBasisLineModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

AddObligationBasisLineModalComponent.template = template;
AddObligationBasisLineModalComponent.controller = controller;

export default AddObligationBasisLineModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addObligationBasisLineModal/addObligationBasisLineModal.component.js